import React, { Component } from 'react';
import { connect, useSelector } from 'react-redux';
import { Menu } from './Styles/Menu';
import { Link } from 'react-router-dom';
import { Map } from 'immutable';
import { generateDisplayName } from './Utils/Person';
import useAuthentication from '@zorgconnect/shared-portal/Modules/Authentication/Service/hooks/useAuthentication';
import { PortalMenu } from '@zorgconnect/shared-portal/Components/PortalMenu';

const mapStateToProps = (state) => ({
    menuOpened: state.getIn(['ui','mainMenuOpened']),
    user: state.getIn(['users','single'], Map())
})

function LogoutButton() {
    
    const { logout } = useAuthentication();

    return <a className="cursor-pointer" onClick={logout}>
        <i className="zmdi zmdi-caret-left-circle" />
        Uitloggen
    </a>


}


const apiUrl = window.location.href.match('localhost:30') ? "http://localhost:8080" : ".";

class MainMenu extends Component {

    

    render() {

        let { menuOpened, user } = this.props;

        let clientportal = user.getIn(['clientportal',0], Map()) || Map();
        let canseedocument = clientportal.get('canseedocuments');

        let aanhef = "mevrouw";
        let lastname = user.get('lastname');
        if(user.get('insertion')) {
            lastname = user.get('insertion') + " " + lastname;
        } 
        if(user.get('gender') == 'M' || user.get('gender') == 'm') {
            aanhef = "meneer";
        }

        return <Menu active={menuOpened} className={(menuOpened ? " open" : " closed")}>
            
             <h2 className="menu-header">Welkom, {aanhef} {lastname}</h2>
            
            <ul className="inner-menu">
                <li>
                    <Link to="/">
                        <i className="zmdi zmdi-calendar" />
                        Planning
                    </Link>
                </li>
                <li>
                    <Link to="/teamcontact">
                        <i className="zmdi zmdi-accounts" />
                        Teamcontact
                    </Link>
                </li>
                { canseedocument && <li>
                    <Link to="/documents">
                        <i className="zmdi zmdi-border-color" />
                        Documenten
                    </Link>
                </li> || null} 
                {/* <li>
                    <Link to="/settings">
                        <i className="zmdi zmdi-settings" />
                        Instellingen
                    </Link>
                </li> */}
                <li>

                    <a href={`https://www.u-staat-centraal.nl/`}>
                        <i className="zmdi zmdi-satellite" />
                        Naar website
                    </a>
                </li>
                <li>
                    <LogoutButton />
                </li>
            </ul>

            <PortalMenu />

            <PortalUserSelector />


        </Menu>


    }

}

export default connect(mapStateToProps)(MainMenu);


function PortalUserSelector() {

    let portalUsers = useSelector(state => state.getIn(['portalusers','collection']));

    console.log("portalUsers from portalUsers", portalUsers);

    if(!portalUsers || portalUsers.size < 2) {
        return null;
    }

    return <React.Fragment>
        <h2 className="menu-header">Portalen</h2>
        <ul className="inner-menu">
            { portalUsers && portalUsers.map((portalUser) => {
                
                let portalType = portalUser.get('usertype') == 'freelancer' ? 'Freelancer portaal' : 'Client portaal';
                let portalUrl = portalUser.get('usertype') == 'freelancer' ? '/selectfreelancerportal/' + portalUser.get('id') : '/selectclientportal/' + portalUser.get('id');

                return  <li>
                    <a href={portalUrl}>
                    {portalType} {portalUser.get('gender') == 'M' ? 'Dhr.' : 'Mw.'} {generateDisplayName(portalUser)} 
                    </a>
                </li>

            }).toList()}
        </ul>

    </React.Fragment>

}